/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './SpringHome.css';

export default function SpringHome() {
  const navigate = useNavigate();

  return (
    <div className="spring-home" data-testid="spring-home">
      {/* Hero */}
      <section className="spring-hero">
        <div className="spring-hero-bg">
          <img src="/spring-hero-blossom-v2.jpg" alt="" />
        </div>
        <div className="spring-hero-gradient" />
        <div className="spring-hero-content">
          <h1 className="spring-hero-headline" data-testid="hero-headline">
            every ending<br />
            is a new<br />
            <span className="petal">beginning.</span>
          </h1>
          <div className="spring-hero-text">
            <p className="spring-hero-body">
              SPRING, a guided programme for people facing a change in work: a redundancy, a career that no longer fits, or the quiet question of what comes next. Self-paced, with human mentors and AI support beside you all the way to your next pathway to income.
            </p>
            <div className="spring-hero-buttons">
              <button
                className="spring-btn-petal"
                onClick={() => navigate('/assessment')}
                data-testid="hero-start-btn"
              >
                Start the Assessment
              </button>
              <button
                className="spring-btn-outline-light"
                onClick={() => {
                  const el = document.getElementById('why-spring');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                data-testid="hero-how-btn"
              >
                How SPRING works
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Why SPRING */}
      <section className="spring-why" id="why-spring">
        <span className="spring-eyebrow">Why SPRING</span>
        <h2 className="spring-why-headline">something new is ready to grow.</h2>
        <p className="spring-why-lead">An online guided journey. In stages, taken one at a time, at your pace, from wherever you are.</p>

        <div className="spring-forest-cards">
          <div className="spring-forest-card">
            <span className="spring-forest-card-num">01</span>
            <h3>the structure</h3>
            <p>The platform walks you through every step. What to do, in what order, and why it matters.</p>
          </div>
          <div className="spring-forest-card">
            <span className="spring-forest-card-num">02</span>
            <h3>the people</h3>
            <p>Real human mentors who have done hard things themselves, and a community walking the same road at the same time as you.</p>
          </div>
          <div className="spring-forest-card">
            <span className="spring-forest-card-num">03</span>
            <h3>the AI coach</h3>
            <p>Available around the clock, because the wobble doesn't keep office hours and sometimes you need someone at 11pm.</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="spring-footer">
        <div className="spring-footer-inner">
          <div className="spring-footer-logo">
            <img src="/spring-logo-colour-tagline.webp" alt="SPRING - growing success stories" />
          </div>
          <div className="spring-footer-right">
            <div className="spring-footer-links">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/assessment">Assessment</Link>
              <Link to="/pathways">Pathways</Link>
            </div>
            <div className="spring-footer-email">
              <a href="mailto:hello@springcollective.biz">hello@springcollective.biz</a>
            </div>
            <div className="spring-footer-copy">
              &copy; Spring Collective Limited 2026
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
